import { Component, OnDestroy, OnInit } from '@angular/core';

import { AlertService, Alert } from 'app/core/utils/alert.util.service';

@Component({
	selector: 'jhi-alert',
	templateUrl: './alert.component.html',
	standalone: false,
})
export class AlertComponent implements OnInit, OnDestroy {
	alerts: Alert[] = [];

	constructor(private alertService: AlertService) {}

	ngOnInit(): void {
		this.alerts = this.alertService.get();
	}

	setClasses(alert: Alert): { [key: string]: boolean } {
		const classes = { 'jhi-toast': Boolean(alert.toast) };
		if (alert.position) {
			return { ...classes, [alert.position]: true };
		}
		return classes;
	}

	ngOnDestroy(): void {
		this.alertService.clear();
	}

	close(alert: Alert): void {
		alert.close?.(this.alerts);
	}
}
